import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import Button from '../common/inputs/button';
import Select from '../common/inputs/select';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';
import BlueHeader from '../common/inputs/blueHeader';
import SelectList from '../common/inputs/selectList';
import BiTemplatesDataObject from './biTemplatesDataObject';

const ExportDataSelectors = props => {
  const {
    onChangeDataFilter,
    metricsGroupsDataFilters,
    metricsGroupsList,
    metricsDataFilters,
    metricsList,
    reportsDataFilters,
    modelsDataFilters,
    modelsList,
    biTemplatesDataFilters,
    biTemplatesList,
    handleSelectBiTemplatesPopup,
  } = props;

  let biTemplatesDataFiltersArray = biTemplatesDataFilters["bi_data_list"];
  biTemplatesDataFiltersArray.map((biObject) => {
    //Iterate every row in the object (biObject is the row)
    let biObjectLabel = "";
    biObject.forEach((biObjectElement, index) => {
      //Iterate every pair in the row (biObjectElement is the pair)
      biObjectLabel += (index>0) ? ", " : "";
      biObjectLabel += modelsList.find((model) => (model.id == biObjectElement["model_id"]))["name"];
      biObjectLabel += ": " + (biObjectElement["template_id"]=="defect" ?
        intl.formatMessage({id: "exportConfigurationsAdmin.templateLabelDefect" }) :
        biTemplatesList.find((biTemplate) => biTemplate.id == biObjectElement["template_id"])["name"]);
    })
    biObject["label"] = biObjectLabel;
    return biObject;
  });
  return (
    <React.Fragment>
      <div className="export_configuration_data_section metric_groups_and_metrics_data">
        <div className="export_configuration_data metric_groups_filter">
          <label className="export_configuration_data_label top_row">{intl.formatMessage({id: "exportConfigurationsAdmin.metricGroupsDataLabel"})}</label>
          <Select 
            value={metricsGroupsDataFilters["metric_groups_criteria"]}
            onChange={onChangeDataFilter}
            labelLocale={<FormattedMessage id="exportConfigurationsAdmin.criteriaSelectorLabel"/>}
            options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.metricGroupsDataFilter", "exportConfigurationsAdmin.criteriaSelectorOptions", false)}
            data-path="metric_groups_criteria"
          />
          {(!(["", Constants.selectKeys.exportConfigurationsAdmin.metricGroupsDataFilter.EMPTY, Constants.selectKeys.exportConfigurationsAdmin.metricGroupsDataFilter.ALL].includes(metricsGroupsDataFilters["metric_groups_criteria"]))) && (
            <SelectList        
              values={metricsGroupsDataFilters["metric_groups_selected"]}
              onChange={onChangeDataFilter}
              addSelectLocale={<FormattedMessage id="exportConfigurationsAdmin.addMetricGroupValue"/>}
              labelLocale={""}
              noMoreOptionsLocale={intl.formatMessage({ id:"exportConfigurationsAdmin.noMoreMetricGroupsOptions" })}
              options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsGroupsList, "id", "name", true, intl.formatMessage({id: "exportConfigurationsAdmin.addMetricGroupValue" }))}
              valueAccesor={"id"}
              labelAccesor={"name"}
              data-path="metric_groups_selected"
            />
          )}
        </div>
        <div className="export_configuration_data metrics_filter">
          <label className="export_configuration_data_label top_row">{intl.formatMessage({id: "exportConfigurationsAdmin.metricDataLabel"})}</label>
          <Select 
            value={metricsDataFilters["metrics_criteria"]}
            onChange={onChangeDataFilter}
            labelLocale={<FormattedMessage id="exportConfigurationsAdmin.criteriaSelectorLabel"/>}
            options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.metricsDataFilter", "exportConfigurationsAdmin.criteriaSelectorOptions", false)}
            data-path="metrics_criteria"
          />
          {(!(["", Constants.selectKeys.exportConfigurationsAdmin.metricsDataFilter.EMPTY, Constants.selectKeys.exportConfigurationsAdmin.metricsDataFilter.ALL].includes(metricsDataFilters["metrics_criteria"]))) && (
            <SelectList        
              values={metricsDataFilters["metrics_selected"]}
              onChange={onChangeDataFilter}
              addSelectLocale={<FormattedMessage id="exportConfigurationsAdmin.addMetricValue"/>}
              labelLocale={""}
              noMoreOptionsLocale={intl.formatMessage({ id:"exportConfigurationsAdmin.noMoreMetricsOptions" })}
              options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList, "id", "name", true, intl.formatMessage({id: "exportConfigurationsAdmin.addMetricValue" }))}
              valueAccesor={"id"}
              labelAccesor={"name"}
              data-path="metrics_selected"
            />
          )}
        </div>
      </div>
      <div className="export_configuration_data_section">
        <div className="export_configuration_data reports_filter">
          <label className="export_configuration_data_label">{intl.formatMessage({id: "exportConfigurationsAdmin.reportsDataLabel"})}</label>
          <Select 
            value={reportsDataFilters["reports_criteria"]}
            onChange={onChangeDataFilter}
            labelLocale={<FormattedMessage id="exportConfigurationsAdmin.criteriaSelectorLabel"/>}
            options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.reportsDataFilter", "exportConfigurationsAdmin.criteriaSelectorOptions", false)}
            data-path="reports_criteria"
          />
        </div>
        <div className="export_configuration_data models_filter">
          <label className="export_configuration_data_label">{intl.formatMessage({id: "exportConfigurationsAdmin.modelsDataLabel"})}</label>
          <Select 
            value={modelsDataFilters["models_criteria"]}
            onChange={onChangeDataFilter}
            labelLocale={<FormattedMessage id="exportConfigurationsAdmin.criteriaSelectorLabel"/>}
            options={InterfaceTooling.getSelectArray("selectKeys.exportConfigurationsAdmin.modelsDataFilter", "exportConfigurationsAdmin.criteriaSelectorOptions", false)}
            data-path="models_criteria"
          />
          {(!(["", Constants.selectKeys.exportConfigurationsAdmin.modelsDataFilter.EMPTY, Constants.selectKeys.exportConfigurationsAdmin.modelsDataFilter.ALL].includes(modelsDataFilters["models_criteria"]))) && (
            <SelectList        
              values={modelsDataFilters["models_selected"]}
              onChange={onChangeDataFilter}
              addSelectLocale={<FormattedMessage id="exportConfigurationsAdmin.addModelValue"/>}
              labelLocale={""}
              noMoreOptionsLocale={intl.formatMessage({ id:"exportConfigurationsAdmin.noMoreModelsOptions" })}
              options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsList, "id", "name", true, intl.formatMessage({id: "exportConfigurationsAdmin.addModelValue" }))}
              valueAccesor={"id"}
              labelAccesor={"name"}
              data-path="models_selected"
            />
          )}
        </div>
      </div>
      <div className="export_configuration_data_section">
        <div className="export_configuration_data bi_templates_filter">
          <label className="export_configuration_data_label">
            {intl.formatMessage({id: "exportConfigurationsAdmin.biTemplatesDataLabel" })}
            {<i className="fas fa-plus-circle" onClick={handleSelectBiTemplatesPopup}/>}
          </label>
          <BiTemplatesDataObject        
            values={biTemplatesDataFilters["bi_data_list"]}
            onChange={onChangeDataFilter}
            addSelectLocale={<FormattedMessage id="exportConfigurationsAdmin.addBiTemplateValue"/>}
            noMoreOptionsLocale={intl.formatMessage({id: "exportConfigurationsAdmin.noMoreBiTemplatesOptions" })}
            options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsGroupsList, "id", "name", true, intl.formatMessage({id: "exportConfigurationsAdmin.addBiTemplateValue" }))}
            valueAccesor={"id"}
            labelAccesor={"label"}
            handleSelectBiTemplatesPopup={handleSelectBiTemplatesPopup}
            data-path="bi_data_list"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExportDataSelectors;



// WEBPACK FOOTER //
// ./source/client/components/exportConfigurationsAdmin/exportDataSelectors.jsx